import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import green from '@material-ui/core/colors/green';
import { withStyles } from '@material-ui/core/styles';
import Notifier, { openSnackbar } from '../notifier';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import api from '../../api/backend'

import CloseIcon from '@material-ui/icons/Close';

const DialogTitle = withStyles(theme => ({
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
        color: theme.palette.grey[500],
    },
}))(props => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography variant="title">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit,
    },
}))(MuiDialogActions);

const styles = theme => ({
    addCourse: {
        marginBottom: 20
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardContent: {
        flexGrow: 1,
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
    drawer: {
        width: 500
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    submit: {
        marginTop: 20
    }
});

class NewUser extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { firstName: '', lastName: '', nickName: '', tel: '', email: '', password: '', address: '', role: '', parentName: '', parentContract: '', show: false, loading: false }
    }

    closeAndClear = () => {
        this.setState({ firstName: '', lastName: '', nickName: '', tel: '', email: '', password: '', address: '', role: '', parentName: '', parentContract: '', show: false, loading: false })
    }

    createUser = (event) => {
        event.preventDefault();
        const { firstName, lastName, nickName, tel, email, password, address, role, status, parentName, parentContract } = this.state
        const { onCreated } = this.props

        this.setState({ loading: true })
        api.createUser({ userName: email, firstName, lastName, nickName, tel, email, password, address, role, status, parentName, parentContract }).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                openSnackbar({ message: 'สร้างผู้ใช้สำเร็จ' })
                if (onCreated) {
                    onCreated()
                }
                setTimeout(() => {
                    this.closeAndClear()
                }, 3000);
            } else {
                console.error('ไม่สามารถสร้างผู้ใช้ใหม่ได้')
                openSnackbar({ message: 'ไม่สามารถสร้างผู้ใช้ใหม่ได้' })
                this.setState({ loading: false });
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
            openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
            this.setState({ loading: false });
        })
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    validate = () => {
        const { firstName, lastName, tel, email, password, role, status } = this.state
        if (firstName && firstName.length > 0 && lastName && lastName.length > 0 && tel && tel.length > 0 && this.validateEmail(email) && password && password.length > 3 && role && status) {
            return true
        } else {
            return false
        }
    }

    render() {
        const { classes } = this.props
        const { firstName, lastName, nickName, tel, email, password, address, role, parentName, parentContract, loading } = this.state
        return (
            <div>
                <Button onClick={() => this.setState({ show: true })}
                    variant="contained"
                    size="large"
                    color="primary"
                    fullWidth
                    className={classes.addCourse}
                >เพิ่มผุ้ใช้งาน</Button>

                <Dialog
                    open={this.state.show}
                    onClose={this.closeAndClear}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">เพิ่มผู้ใช้งาน</DialogTitle>
                    <DialogContent>
                        <Notifier />
                        <Grid container spacing={24}>
                            {/* <Grid item xs={12}>
                                <TextField
                                    required
                                    id="userName"
                                    name="userName"
                                    label="ชื่อเข้าใช้ระบบ"
                                    fullWidth
                                    autoComplete="user userName"
                                    value={userName}
                                    onChange={(event) => { this.setState({ userName: event.target.value }) }}
                                />
                            </Grid> */}
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="email"
                                    name="email"
                                    label="อีเมลล์"
                                    fullWidth
                                    autoComplete="user email"
                                    value={email}
                                    onChange={(event) => { this.setState({ email: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    type="password"
                                    id="password"
                                    name="password"
                                    label="พาสเวิร์ด"
                                    fullWidth
                                    autoComplete="user password"
                                    value={password}
                                    onChange={(event) => { this.setState({ password: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="firstName"
                                    name="firstName"
                                    label="ชื่อ"
                                    fullWidth
                                    autoComplete="user firstName"
                                    value={firstName}
                                    onChange={(event) => { this.setState({ firstName: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="lastName"
                                    name="lastName"
                                    label="นามสกุล"
                                    fullWidth
                                    autoComplete="user lastName"
                                    value={lastName}
                                    onChange={(event) => { this.setState({ lastName: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="nickName"
                                    name="nickName"
                                    label="ชื่อเล่น"
                                    fullWidth
                                    autoComplete="user nickName"
                                    value={nickName}
                                    onChange={(event) => { this.setState({ nickName: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="tel"
                                    name="tel"
                                    label="เบอร์โทรศัพท์"
                                    fullWidth
                                    autoComplete="user tel"
                                    value={tel}
                                    onChange={(event) => { this.setState({ tel: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="parentName"
                                    name="parentName"
                                    label="ชื่อผู้ปกครอง"
                                    fullWidth
                                    autoComplete="user parentName"
                                    value={parentName}
                                    onChange={(event) => { this.setState({ parentName: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="parentContract"
                                    name="parentContract"
                                    label="เบอร์โทรศัพท์ผู้ปกครอง"
                                    fullWidth
                                    autoComplete="user parentContract"
                                    value={parentContract}
                                    onChange={(event) => { this.setState({ parentContract: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="address"
                                    name="address"
                                    label="ที่อยู่"
                                    fullWidth
                                    multiline
                                    rows={5}
                                    autoComplete="course address"
                                    value={address}
                                    onChange={(event) => { this.setState({ address: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl className={classes.formControl} required>
                                    <InputLabel htmlFor="role-helper">ประเภทผู้ใช้งาน</InputLabel>
                                    <Select
                                        value={role}
                                        onChange={(event) => { this.setState({ role: event.target.value }) }}
                                        input={<Input name="role" id="role-helper" required />}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="Student">นักเรียน</MenuItem>
                                        <MenuItem value="Instructor">ผู้สอน</MenuItem>
                                    </Select>
                                    <FormHelperText>เลือกประเภทผู้ใช้งาน นักเรียน หรือผู้สอน</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl className={classes.formControl} required>
                                    <InputLabel htmlFor="role-helper">สถานะ</InputLabel>
                                    <Select
                                        value={this.state.status}
                                        onChange={(event) => { this.setState({ status: event.target.value }) }}
                                        input={<Input name="status" id="status-helper" required />}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="waiting">รอการอนุมัติ</MenuItem>
                                        <MenuItem value="approve">อนุมัติ</MenuItem>
                                    </Select>
                                    <FormHelperText>เลือกประเภทผู้ใช้งาน นักเรียน หรือผู้สอน</FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeAndClear} color="default" disabled={loading}>
                            ปิด
                        </Button>
                        <Button onClick={this.createUser} color="primary" disabled={loading || !this.validate()}>
                            สร้างผู้ใช้งาน
                        </Button>
                        {loading ? <CircularProgress size={24} className={classes.buttonProgress} /> : <React.Fragment>
                        </React.Fragment>}
                    </DialogActions>
                </Dialog>

                {/* <Drawer anchor="right" open={this.state.show} classes={{
                    paper: classes.drawer,
                }} onClose={this.closeAndClear}>

                    <Notifier />
                    <Card className={classes.card}>
                        <CardHeader
                            title={<Typography variant="title" gutterBottom>
                                เพิ่มผู้ใช้งาน
                            </Typography>} />
                        <CardContent className={classes.cardContent}>
                            <form className={classes.form} onSubmit={this.createUser}>
                                <Grid container spacing={24}>
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            id="userName"
                                            name="userName"
                                            label="ชื่อเข้าใช้ระบบ"
                                            fullWidth
                                            autoComplete="user userName"
                                            value={userName}
                                            onChange={(event) => { this.setState({ userName: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            type="password"
                                            id="password"
                                            name="password"
                                            label="พาสเวิร์ด"
                                            fullWidth
                                            autoComplete="user password"
                                            value={password}
                                            onChange={(event) => { this.setState({ password: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            required
                                            id="firstName"
                                            name="firstName"
                                            label="ชื่อ"
                                            fullWidth
                                            autoComplete="user firstName"
                                            value={firstName}
                                            onChange={(event) => { this.setState({ firstName: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            required
                                            id="lastName"
                                            name="lastName"
                                            label="นามสกุล"
                                            fullWidth
                                            autoComplete="user lastName"
                                            value={lastName}
                                            onChange={(event) => { this.setState({ lastName: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            required
                                            id="nickName"
                                            name="nickName"
                                            label="ชื่อเล่น"
                                            fullWidth
                                            autoComplete="user nickName"
                                            value={nickName}
                                            onChange={(event) => { this.setState({ nickName: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            required
                                            id="tel"
                                            name="tel"
                                            label="เบอร์โทรศัพท์"
                                            fullWidth
                                            autoComplete="user tel"
                                            value={tel}
                                            onChange={(event) => { this.setState({ tel: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            id="email"
                                            name="email"
                                            label="อีเมลล์"
                                            fullWidth
                                            autoComplete="user email"
                                            value={email}
                                            onChange={(event) => { this.setState({ email: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            id="address"
                                            name="address"
                                            label="ที่อยู่"
                                            fullWidth
                                            multiline
                                            rows={5}
                                            autoComplete="course address"
                                            value={address}
                                            onChange={(event) => { this.setState({ address: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl className={classes.formControl} required>
                                            <InputLabel htmlFor="role-helper">ประเภทผู้ใช้งาน</InputLabel>
                                            <Select
                                                value={role}
                                                onChange={(event) => { this.setState({ role: event.target.value }) }}
                                                input={<Input name="role" id="role-helper" required />}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                <MenuItem value="Student">นักเรียน</MenuItem>
                                                <MenuItem value="Instructor">ผู้สอน</MenuItem>
                                            </Select>
                                            <FormHelperText>เลือกประเภทผู้ใช้งาน นักเรียน หรือผู้สอน</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <div className={classes.wrapper}>
                                    <Button
                                        type="submit"
                                        variant="raised"
                                        color="primary"
                                        disabled={loading}
                                        className={classes.submit}
                                        size="large"
                                        fullWidth
                                    >
                                        สร้างผู้ใช้งาน
                                    </Button>
                                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </div>
                            </form>
                        </CardContent>
                    </Card>
                </Drawer> */}
            </div>
        );
    }
}

export default withStyles(styles)(NewUser);